import React, { memo } from "react";
import { Row, Col, Typography } from "antd";

import inaamStars from "media/inaamstars.png";
import dashBoardIllustration from "media/dashboardIllustration.png";

const { Text } = Typography;

const DataRenderer = (props) => {
  const activityDetails = [
    // {
    // 	text: "Total Users",
    // 	data: props.loading || !props.data ? "..." : props.data?.totalUsers,
    // },
    {
      text: "New Registered Users",
      data:
        props.loading || !props.data ? "..." : props.data?.total_users,
    },
    {
      text: "Promos Generated",
      data: props.loading || !props.data ? "..." : props.data?.promos_generated,
    },
    {
      text: "Vouchers Generated",
      data:
        props.loading || !props.data ? "..." : props.data?.vouchers_generated,
    },
  ];

  return (
    <Row
      gutter={[12, 12]}
      type="flex"
      align="middle"
      style={{
        backgroundColor: "#f2e09d3b",
        padding: "10px 30px 10px 10px",
        borderRadius: "12px",
      }}
    >
      {/* illustration */}
      <Col span={4}>
        <img
          src={dashBoardIllustration}
          style={{
            width: "100%",
          }}
        />
      </Col>

      {/* data */}
      <Col span={20}>
        <Row type="flex">
          <Col>
            <img
              src={inaamStars}
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          </Col>
          <Col>
            <Text
              style={{
                fontSize: "18px",
                marginLeft: "5px",
                color: "#fec708",
              }}
            >
              <span style={{ fontWeight: "bold" }}>Today’s</span> Activity on
              Nujoom App
            </Text>
          </Col>
        </Row>
        <Row
          type="flex"
          gutter={[48, 24]}
          style={{
            marginTop: "20px",
          }}
        >
          {activityDetails.map((activity, index) => (
            <Col key={index} style={{ flexGrow: 1 }}>
              <Text
                style={{
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "24px",
                  lineHeight: "39px",
                  color: "#fec708",
                }}
              >
                {activity.data}
              </Text>
              <br />
              <Text
                style={{
                  fontStyle: "normal",
                  fontWeight: "normal",
                  fontSize: "14px",
                  lineHeight: "22px",
                  color: "#fec708",
                }}
              >
                {activity.text}
              </Text>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default memo(
  DataRenderer,
  (prevProps, nextProps) => prevProps.data === nextProps.data
);
